import React from 'react'

// 說明：免登入頁面
export const withoutAuthRoute = [
    {
        key: 'work.order.vendor.detail',
        path: `/public/work-order-vendor-detail/:accessKey/:serviceOrderId`,
        component: React.lazy(() => import('views/work-order-vendor-detail')),
        authority: [],
    },
]
